import React, {useState, useEffect} from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Aside from '../components/Aside';
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { confirmAlert } from 'react-confirm-alert';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables';


const Subscriptions = () => {
    const [subscriptions, setSubscriptions] = useState([])
	const [loading, setLoading] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [subscription, setSubscription] = useState([])
    const [isValid, setIsValid] = useState(false)
    const [email, setEmail] = useState('')
    const [id, setId] = useState('')

    useEffect(() => {
		populate()
	}, [])

    useEffect(() => {
        if (!loading && subscriptions.length > 0) {
            const table = $('#subscription_config').DataTable({
                order: [[11, 'desc']]
            });
            return () => table.destroy(); // cleanup before re-render
        }
    }, [loading, subscriptions]);

    const handleClosePopup = () => {
		setShowForm(false);
	}

    const handleEditSubscription = (e, sid) => {
        e.preventDefault()
        setShowForm(true);
       
        const selected = subscriptions.find(item => item.id === sid); // use find instead of filter
        if (selected) {
            setSubscription(selected);
            setEmail(selected.email);
            setId(selected.id);
        } else {
            console.warn("Subscription not found for ID:", sid);
        }
    }


    useEffect(() => {
        const valid = email ? email.length > 0 : false;
            setIsValid(valid);
    }, [email])

    
    const populate = () => {
		setLoading(true)
        const endpoint = process.env.REACT_APP_BASE_URL + '/subscriptions/all';
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify({"key_id" : process.env.REACT_APP_BASE_APIKEY})
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error === true){
                setLoading(false)
            }else{
                setSubscriptions(response.data)
                setLoading(false)
                setShowForm(false);
	        }
           
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

    const cancelSubscription = (e, subscription_reference) => {
        e.preventDefault();
        confirmAlert({
            title: 'Cancel subscription',
            message: 'Are you sure you want to cancel this subscription. This will disable the subscription from your payment platform (2checkout)',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => validateCancelSubscription(subscription_reference)
                },
                {
                    label: 'No',
                    // onClick: () => alert('Click No')
                }
            ]
        });
    }

    const activateSubscription = (e, subscription_reference) => {
        e.preventDefault();
        confirmAlert({
            title: 'Activate subscription',
            message: 'Are you sure you want to reactivate this subscription. This will enable the subscription from your payment platform (2checkout)',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => validateActivateSubscription(subscription_reference)
                },
                {
                    label: 'No',
                    // onClick: () => alert('Click No')
                }
            ]
        });
    }

    const validateCancelSubscription = (subscription_reference) => {
        const endpoint = process.env.REACT_APP_BASE_URL + '/subscription/y99d5wwzft/disable';

        const payload = {
            "subscription_reference" : subscription_reference, 
            "key_id" : process.env.REACT_APP_BASE_APIKEY
        };  
        
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(response => { 
            if(response.action === true){
                toast.success("The subscription has been successfully canceled!");
                populate()
            }else{
                toast.error("Error to cancel the subscription!");
            }
           
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

    const validateActivateSubscription = (subscription_reference) => {
        const endpoint = process.env.REACT_APP_BASE_URL + '/subscription/y99d5wwzft/enable';
        const payload = {
            "subscription_reference" : subscription_reference, 
            "key_id" : process.env.REACT_APP_BASE_APIKEY
        };  
        
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(response => { 
            if(response.action === true){
                toast.success("The subscription has been successfully activated!");
                populate()
            }else{
                toast.error("Error to activate the subscription!");
            }
           
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }


    const saveSubscription = (e) => {
        e.preventDefault()
        setLoading(true)
       
        const endpoint = process.env.REACT_APP_BASE_URL + '/subscription/update/useremail';

        const payload = {
            "email" : email, 
            "id" : id, 
            "key_id" : process.env.REACT_APP_BASE_APIKEY
        };  
        
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error === true){
                setLoading(false)
            }else{
                populate()
                //setLoading(false)
            }
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

 	return (

    <>
    
    <div
		id="main-wrapper"
		data-layout="vertical"
		data-navbarbg="skin5"
		data-sidebartype="full"
		data-sidebar-position="absolute"
		data-header-position="absolute"
		data-boxed-layout="full"
    >
		<Header />
		<Aside page="subscriptions"/>
        <ToastContainer 
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
            draggable
        />
		<div className="page-wrapper">
			<div className="page-breadcrumb">
				<div className="row">
					<div className="col-12 d-flex no-block align-items-center">
					<h4 className="page-title">Subscriptions</h4>
					<div className="ms-auto text-end">
						<nav aria-label="breadcrumb">
						<ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
							<li className="breadcrumb-item active" aria-current="page">
							Subscriptions
							</li>
						</ol>
						</nav>
					</div>
					</div>
				</div>
			</div>
		
			<div className="container-fluid">
				<div className="row">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Subscriptions</h5>
                            {
							loading ? 
                                <ClipLoader
                                    color="fff"
                                    loading={loading}
                                    size={10}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                /> : 
                                <div className="table-responsive">
                                    <table
                                    id="subscription_config"
                                    className="table table-striped table-bordered"
                                    >
                                        <thead style={{ fontWeight:'bold' }}>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th>Email</th>
                                                <th>Purchase Email</th>
                                                <th>Licence</th>
                                                <th>Pdt</th>
                                                <th>Qty</th>
                                                <th>Price</th>
                                                <th>Currency</th>
                                                <th>Start Date</th>
                                                <th>Expiration Date</th>
                                                <th>Order Status</th>
                                                <th>Subsription Status</th>
                                                <th>Creation Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                subscriptions.map((item, i) => (
                                                    <tr key={i}>
                                                        {
                                                        item.subscription_status === 'ACTIVE' ? 
                                                            <td>
                                                                <button type="button" className="btn btn-danger btn-sm text-white" onClick={(e) => cancelSubscription(e, item.subscription_reference)}>Cancel</button>
                                                            </td>
                                                        :
                                                            <td>
                                                                <button type="button" className="btn btn-cyan btn-sm text-white" onClick={(e) => activateSubscription(e, item.subscription_reference)}>Activate</button>
                                                            </td>
                                                        }
                                                        <td><button type="button" className="btn btn-cyan btn-sm text-white" onClick={(e) => handleEditSubscription(e, item.id)}>Edit</button></td>
                                                        <td>{item.email}</td>
                                                        <td>{item.purchase_email}</td>
                                                        <td>{item.subscription_reference}</td>
                                                        <td>{item.ipn_pname}</td>
                                                        <td>{item.ipn_qty}</td>
                                                        <td>{item.price}</td>
                                                        <td>{item.currency}</td>
                                                        <td>{item.startDate}</td>
                                                        <td>{item.expirationDate}</td>
                                                        <td>{item.orderstatus}</td>
                                                        {
                                                        item.subscription_status === 'ACTIVE' ? 
                                                            <td>
                                                                <button type="button" className="btn btn-success btn-sm text-white" style={{"cursor":"default"}}>{item.subscription_status}</button></td>
                                                            :
                                                            <td>
                                                                <button type="button" className="btn btn-danger btn-sm text-white" style={{"cursor":"default"}}>{item.subscription_status}</button></td>
                                                        }
                                                         <td>{item.creation_date}</td>
                                                    </tr>
                                                ))
                                            }                            
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th>Email</th>
                                                <th>Purchase Email</th>
                                                <th>Licence</th>
                                                <th>Pdt</th>
                                                <th>Qty</th>
                                                <th>Price</th>
                                                <th>Currency</th>
                                                <th>Start Date</th>
                                                <th>Expiration Date</th>
                                                <th>Order Status</th>
                                                <th>Subsription Status</th>
                                                <th>Creation Date</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                     { showForm && (
                                            <>
                                                <div className="login-overlay overlay"></div>
                                                <div id="loginformplan" style={{ minHeight:'unset' }}>
                                                    <div className="content">
                                                        <div className="login-close" onClick={handleClosePopup}></div>
                                                        <div className="title">
                                                            <h4 className="box-title mb-3">Update User Email</h4>
                                                            <h5 style={{fontWeight: "400", fontSize: "11px"}}>This is the email used to connect to the platform</h5>
                                                        </div>
                                                    
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <form>
                                                                    
                                                                    <div className="mb-3 form-group required">
                                                                        <label htmlFor="Email" className="form-label">Email</label>
                                                                        <input type="text" className="form-control" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                                    </div>
                                                                    
                                                                    <div style={{display: 'flex', width: '100%', justifyContent: 'end'}}>
                                                                        <button type="submit" className="btn btn-primary text-medium btn-border-radius" onClick={saveSubscription} disabled={!isValid}>Save</button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                </div>
                            }
                        </div>
                    </div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
	</>
  	);
}

export default Subscriptions;
